import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'

const CreateEventOrLeague = ({ handleNext, details, setDetails }) => {
  const handleClick = (e, chosenType) => {
    setDetails({ ...details, product: chosenType.toLowerCase()})
    handleNext({ chosenType })
    e.preventDefault()
  }

  const buttonsArray = [
    {
      title: window.I18n.t('customer_center_menu.components.popups.sim_golf.create_event_button'),
      info: window.I18n.t('customer_center_menu.components.popups.sim_golf.create_event_button_info'),
      type: window.I18n.t('customer_center_menu.components.popups.sim_golf.create_event_button'),
    },
    {
      title: window.I18n.t('customer_center_menu.components.popups.sim_golf.create_league_button'),
      info: window.I18n.t('customer_center_menu.components.popups.sim_golf.create_league_button_info'),
      type: window.I18n.t('customer_center_menu.components.popups.sim_golf.create_league_button'),
    },
  ]

  return (
    <div className='popup_form_content'>
      <h2>{ window.I18n.t('customer_center_menu.components.popups.sim_golf.create_event_or_league_header') }</h2>
      { buttonsArray.map( button =>
        <button onClick={ (e) => handleClick(e, button.type) }>
          <div>
            <div className='button_header'>
              <span className='button_title'>{ button.title }</span>
            </div>
            <span className='button_subtitle'>{ button.info }</span>
          </div>
        </button>
      )}
    </div>
  )
}

CreateEventOrLeague.propTypes = {
  handleNext: PropTypes.func.isRequired,
  details: PropTypes.object.isRequired,
  setDetails: PropTypes.func.isRequired,
}

export default CreateEventOrLeague
